<div class="card bg-2">
    <div class="card-body">
        <mat-horizontal-stepper class="bg-2 form-group row" #stepper (animationDone)="selectionChanged()">
            <mat-step label="Seleção regras">
                <selecao-regras #selecaoRegrasComponent [buscaRegraComposta]="true" [associacao]="true" (onRegraChange)="updateRegra($event)"></selecao-regras>
            </mat-step>
            <mat-step label="Seleção carteiras">
                <selecao-carteira #selecaoCarteiraComponent (onCarteiraChange)="updateCarteira($event)"></selecao-carteira>
            </mat-step>
            <mat-step label="Execução/vigência">
                <execucao-vigencia #execucaoVigenciaComponent [carteiraRegra$]="carteiraRegra$"
                                   (onDataFilled)="updateVigencia($event)"></execucao-vigencia>
            </mat-step>
        </mat-horizontal-stepper>
    </div>
</div>

<div class="card mb-4 mt-1 bg-2">
    <div class="card-footer">
        <div class="d-flex flex-row justify-content-end">
            <div class="">
                <button mat-raised-button color="primary" title="Gravar" aria-label="left" (click)="doneStepper()"
                        [disabled]="isDisabled">
                    <loading-icon [btnLabel]="'Gravar'" [loading]="loading$ | async"></loading-icon>
                </button>
            </div>
        </div>
    </div>
</div>
